"use client"

import { motion } from "framer-motion"
import RoughEmeraldCard from "./rough-emerald-card"
import { roughEmeralds } from "./rough-emeralds-data"

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
}

export default function RoughEmeraldsGrid() {
  return (
    <div className="max-w-7xl mx-auto px-6 py-12">
      <motion.div
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
        variants={container}
        initial="hidden"
        animate="show"
      >
        {roughEmeralds.map((emerald) => (
          <RoughEmeraldCard key={emerald.id} emerald={emerald} />
        ))}
      </motion.div>
    </div>
  )
}
